import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { problems } from '../data/problems';
export function ProblemSection() {
  return <section className="bg-stage py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-220" data-mp="30h7kvn5mjqti">
      <div className="mx-auto max-w-4xl px-4" data-id="element-221" data-mp="30jaml4g538e2">
        <div className="text-center" data-id="element-222" data-mp="2vq7nkgslf6qh">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-gold" data-id="element-223" data-mp="2vp6euiz1uwbx">La realidad profesional</p>
          <h2 id="problem-title" className="mx-auto mt-3 max-w-3xl text-balance text-3xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-224" data-mp="39jyz1upvx0ou">
            ¿Cuántas clases más vas a preparar sobre Museología sin tener el material correcto?
          </h2>
          <p className="mx-auto mt-5 max-w-3xl leading-relaxed text-mutedDark" data-id="element-225" data-mp="3ei0hqejeexzs">
            Buscás información en internet que no tiene secuencia didáctica ni menciona la realidad de los museos argentinos.
            Armás planificaciones desde cero cada ciclo lectivo. Y cuando un alumno pregunta cómo documentar una colección, qué
            dice la normativa internacional sobre conservación preventiva, cómo diseñar una exposición con presupuesto limitado
            en una comunidad rural, cómo aplicar mediación educativa en contextos de accesibilidad inclusiva o qué hace
            realmente un museólogo en una institución pública argentina en 2026, no tenés una respuesta que los enganche con la
            realidad del campo museológico argentino.
          </p>
          <p className="mt-4 font-bold text-gold" data-id="element-226" data-mp="1726e6lcjpey2">No es falta de vocación profesional. Es que nadie armó el sistema completo para vos.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="panel-dark mt-9 rounded-2xl border border-violet p-6 sm:p-8" data-id="element-227" data-mp="1c2kaj64sb0g9">
          <p className="mb-5 font-display text-xl font-bold text-mutedDark" data-id="element-228" data-mp="3hv0rs7plcm8s">Esto te está pasando ahora mismo:</p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-229" data-mp="p23ml7hyn4jo">
            {problems.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-onDark" data-id="element-230" data-mp="k3aa9ieetjl3">
                <span className="mt-0.5 shrink-0 rounded-full bg-violet/50 p-1" data-id="element-231" data-mp="y29xqmq6rsfo">
                  <XIcon className="h-3.5 w-3.5 text-mutedDark" data-id="element-232" data-mp="tyk77rpyb0s0" />
                </span>
                {item}
              </li>)}
          </ul>
        </motion.div>

        <p className="mt-8 text-center font-bold text-gold" data-id="element-233" data-mp="130thcghb4s4v">
          ¿Y si esta fuera la última semana que enseñás Museología sin tener todo resuelto?
        </p>

        <p className="mx-auto mt-6 max-w-3xl text-center leading-relaxed text-mutedDark" data-id="element-234" data-mp="1cpuxq7rrlbjd">
          Con el MEGAPACK MUSEOLOGÍA LISTO, tu próxima clase ya empieza diferente. Tus alumnos no aprenden museología como un
          conjunto de conceptos abstractos: aprenden que cada museo existe porque alguien decidió que el patrimonio, la memoria
          y la inclusión son derechos fundamentales.
        </p>
      </div>
    </section>;
}